module.exports = __webpack_public_path__ + "img/20210324_212536.d06dcce8.jpg";